(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["contact-form-pro"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change', (e) => {
    const input = e.target;
    if (!(input instanceof HTMLInputElement)) return;

    /* ===== 1) Collaborateurs : sélection unique (checkbox group) ===== */
    if (input.type === 'checkbox') {
      const group = input.closest('[data-single-checkbox-group]');
      if (group && input.checked) {
        group.querySelectorAll('input[type="checkbox"]').forEach((cb) => {
          if (cb !== input) cb.checked = false;
        });
      }
    }

    /* ===== 2) Machines : multi-choix => 1 champ hidden Shopify ===== */
    const machineFieldset = input.closest('[data-machine-fieldset]');
    if (machineFieldset) {
      const hidden = machineFieldset.querySelector('[data-machine-hidden]');
      if (!hidden) return;

      const selected = Array.from(machineFieldset.querySelectorAll('input[data-machine-option]:checked'))
        .map((cb) => cb.value.trim())
        .filter(Boolean);

      hidden.value = selected.join(', ');
    }
  });

  /* Init au chargement (si jamais la page conserve des checks) */
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-machine-fieldset]').forEach((fs) => {
      const hidden = fs.querySelector('[data-machine-hidden]');
      if (!hidden) return;

      const selected = Array.from(fs.querySelectorAll('input[data-machine-option]:checked'))
        .map((cb) => cb.value.trim())
        .filter(Boolean);

      hidden.value = selected.join(', ');
    });
  });

document.addEventListener('DOMContentLoaded', () => {
  const form = document.querySelector('.contact-form__form');
  if (!form) return;

  const submitBtn = form.querySelector('button[type="submit"]');
  const hpInput = form.querySelector('#ContactForm-website');
  const tsInput = form.querySelector('[data-hp-ts]');

  // Timestamp côté client
  const loadedAt = Date.now();
  if (tsInput) tsInput.value = String(loadedAt);

  // Petit délai avant autoriser l'envoi
  const MIN_DELAY_MS = 2500;
  if (submitBtn) {
    submitBtn.disabled = true;
    submitBtn.setAttribute('aria-disabled', 'true');

    window.setTimeout(() => {
      submitBtn.disabled = false;
      submitBtn.removeAttribute('aria-disabled');
    }, MIN_DELAY_MS);
  }

  // Message d'erreur inline (sans casser ton design)
  const showInlineError = (msg) => {
    let box = form.querySelector('.contact-form__notice.contact-form__error[data-hp-error]');
    if (!box) {
      box = document.createElement('div');
      box.className = 'contact-form__notice contact-form__error';
      box.setAttribute('data-hp-error', 'true');
      box.setAttribute('tabindex', '-1');
      box.innerText = msg;
      form.prepend(box);
    } else {
      box.innerText = msg;
    }
    box.focus();
  };

  form.addEventListener('submit', (e) => {
    // 1) Honeypot rempli => bot
    if (hpInput && hpInput.value && hpInput.value.trim().length > 0) {
      e.preventDefault();
      e.stopPropagation();
      return; // on bloque sans message (bots)
    }

    // 2) Envoi trop rapide => probable bot
    const elapsed = Date.now() - loadedAt;
    if (elapsed < MIN_DELAY_MS) {
      e.preventDefault();
      e.stopPropagation();
      showInlineError("Veuillez patienter une seconde puis réessayer.");
    }
  }, true);
});
  } catch(e) { console.error(e); }
})();

})();
